import { FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { getTabName } from '../../utils/productions';
import OkModal from './OkModal';

interface Props {
  editModeTabIndex: number;
  onClickOk: () => void;
}

/**
 * 他のタブがロックされているエラー表示するモーダル
 * @param param0
 * @returns
 */
function AnotherTabLockingErrorModal({ editModeTabIndex, onClickOk }: Props) {
  const { t } = useTranslation();

  return (
    <OkModal onClickOk={onClickOk}>
      {t('{{tab}}が編集中のため、このタブを編集できません。', {
        tab: getTabName(editModeTabIndex, t),
      } as FieldValues).toString()}
    </OkModal>
  );
}

export default AnotherTabLockingErrorModal;
